export default "__VITE_ASSET__xx9TmGVk__"